import React from 'react'
import styled from 'styled-components'

export const SRowDivider = styled.hr`
    background-color: ${({ theme }) => theme.brandColors.CA_Light_Gray};
    width: 100%;
    margin: 20px 0px;
    border: unset;
`

const TextDiv = styled.div`
    position: absolute;
    top: 12px;
    background-color: white;
    padding: 0 2rem;
`

type RowDividerProps = {
    text?: string
}

const RowDivider = ({ text }: RowDividerProps) => {
    return (
        <div className="w-full flex align-items-center justify-content-center relative">
            {text && <TextDiv>{text}</TextDiv>}
            <SRowDivider />
        </div>
    )
}

export default RowDivider
